import { render, staticRenderFns } from "./FlexiTable.vue?vue&type=template&id=38c2d149&scoped=true"
import script from "./FlexiTable.vue?vue&type=script&lang=js"
export * from "./FlexiTable.vue?vue&type=script&lang=js"
import style0 from "./FlexiTable.vue?vue&type=style&index=0&id=38c2d149&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c2d149",
  null
  
)

export default component.exports